import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { lazy, Suspense } from "react";

import { LoadingScreen } from "@/modules/shared/atoms/loading-screen";
import WelcomePage from "@/pages/welcome-page";

const PlanetPage = lazy(() => import("@/pages/planet-page"));
const ReputationPage = lazy(() => import("@/pages/reputation-page"));
const OnboardingPage = lazy(() => import("@/pages/onboarding-page"));
const SocialsPage = lazy(() => import("src/pages/socials-page"));
const LeaderboardPage = lazy(() => import("@/pages/leaderboard-page"));
const AchievementsPage = lazy(() => import("@/pages/achievements-page"));
const ProfilePage = lazy(() => import("@/pages/profile-page"));
const ContributorsPage = lazy(() => import("@/pages/contributors-page"));

import App from "./App";

const Router = () => (
  <BrowserRouter>
    <Routes>
      <Route element={<App />} path="/">
        <Route
          index
          element={
            <Suspense fallback={<LoadingScreen />}>
              <WelcomePage />
            </Suspense>
          }
        />
        <Route
          path="/planet"
          element={
            <Suspense fallback={<LoadingScreen />}>
              <PlanetPage />
            </Suspense>
          }
        />
        <Route
          path="/reputation"
          element={
            <Suspense fallback={<LoadingScreen />}>
              <ReputationPage />
            </Suspense>
          }
        />
        <Route
          path="/onboarding"
          element={
            <Suspense fallback={<LoadingScreen />}>
              <OnboardingPage />
            </Suspense>
          }
        />
        <Route
          path="/socials"
          element={
            <Suspense fallback={<LoadingScreen />}>
              <SocialsPage />
            </Suspense>
          }
        />
        <Route
          path="/leaderboard"
          element={
            <Suspense fallback={<LoadingScreen />}>
              <LeaderboardPage />
            </Suspense>
          }
        />
        <Route
          path="/achievements"
          element={
            <Suspense fallback={<LoadingScreen />}>
              <AchievementsPage />
            </Suspense>
          }
        />
        <Route
          path="/profile/:id?"
          element={
            <Suspense fallback={<LoadingScreen />}>
              <ProfilePage />
            </Suspense>
          }
        />
        <Route
          path="/contributors"
          element={
            <Suspense fallback={<LoadingScreen />}>
              <ContributorsPage />
            </Suspense>
          }
        />
      </Route>
      <Route element={<Navigate replace to="/" />} path="*" />
    </Routes>
  </BrowserRouter>
);

export default Router;
